import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: '',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'photo.png',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://www.linkedin.com/in/kevin-lain-sierra-090610135/', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'lsw.png',
    title: 'Live Status -Instaleap',
    info:
      'I helped build this app while working for the startup Instaleap, an application that allows end customers to track their orders live. I collaborated on the migration from ReactJS to Vue.',
    url:
      'https://xandar-lsw-v3.instaleap.io/?job=ea44e6a5-c9ee-4296-a985-d092c207d665&token=h3hELfJ9OaF5EIj4g8dX6UFm9CTT8p5EaoIIMBJX&hideDeliveryCode=true',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'lloreda.png',
    title: 'Lloreda Camacho - Firm Law',
    info:
      'Website developed while I was working for Digisap Marketing agency, this site was developed with Wordpress, elementor, custom fields and the customization of the theme.',
    url: 'https://lloredacamacho.com/',
  },
  {
    id: nanoid(),
    img: 'mirador.png',
    title: 'Mirador del campo',
    info:
      'Website developed while I was working for Digisap Marketing agency, this site was developed with Gatsby.JS and the form was made using cloud functions with Firebase, Google and Facebook Pixel analytics were implemented.',
    info2: '',
    url: 'https://miradordelcampo.com.co/',
    repo: '', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'klsierraj47@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/kevin-sierra-090610135/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/klsierraj',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: true, // set to false to disable the GitHub stars/fork buttons
};
